import s from "./design-system.es38.js";
import l from "./design-system.es58.js";
import { resolveComponent as t, openBlock as c, createBlock as i, normalizeClass as d, withCtx as r, renderSlot as m, createVNode as u } from "vue";
/* empty css                    */
import f from "./design-system.es128.js";
const _ = {
  name: "DsIconButton",
  components: { DsButton: s, Icon: l },
  props: {
    /**
     * Icon name to render
     */
    name: String,
    /**
     * Name of the element type to render the Button as.  Defaults to a button element, but can be used to render an anchor for links that look like buttons.
     */
    as: {
      type: String,
      default: "button"
    },
    /**
     * The type attribute used by the rendered button, i.e. button, submit, reset.  Defaults to button.  This will not be used if the `as` prop is overriden.
     */
    type: String,
    /**
     * Style as floating
     */
    floating: Boolean,
    /**
     * Label to render for screen readers
     * https://dequeuniversity.com/rules/axe/3.5/button-name?application=axeAPI
     */
    ariaLabel: String,
    /**
     * Styles as a dense variant.
     */
    dense: Boolean,
    /**
     * Disables the button.
     */
    disabled: Boolean
  }
};
function b(e, B, n, g, p, y) {
  const o = t("Icon"), a = t("DsButton");
  return c(), i(a, {
    variant: "custom",
    as: n.as,
    type: n.type,
    dense: n.dense,
    disabled: n.disabled,
    "aria-label": n.ariaLabel,
    class: d(["ds-icon-button icon-only", {
      "ds-icon-button--dense": n.dense,
      "ds-icon-button--floating": n.floating,
      // legacy classes kept for selector backwards compatibility
      floating: n.floating
    }])
  }, {
    default: r(() => [
      m(e.$slots, "default", {}, () => [
        u(o, { name: n.name }, null, 8, ["name"])
      ], !0)
    ]),
    _: 3
  }, 8, ["as", "type", "dense", "disabled", "aria-label", "class"]);
}
const C = /* @__PURE__ */ f(_, [["render", b], ["__scopeId", "data-v-e78c0cd5"]]);
export {
  C as default
};
//# sourceMappingURL=design-system.es59.js.map
